import { Environment } from 'src/Environment';
import { request } from 'src/services/request';
import { LoggingService } from './logging-service';
import { getBrowserName, getOSName } from 'src/helpers/browser';
import { Application } from '../types';
import { getCurrentStep, getLoggingTraceId } from 'src/helpers/logging';
import { getJourneyNameFromSessionStorage } from 'src/utils/SessionStorage/GetJourneyNameFromSessionStorage';

export interface CategoryHitDTO {
  category: string;
  category_description: string;
  description: string;
  fasttrack_mapping: string;
  mcc: string;
  name: string;
  sic: string;
  tags: string;
}

export interface CategoryHit {
  category: string;
  categoryDescription: string;
  description: string;
  fasttrackMapping: string;
  mcc: string;
  name: string;
  sic: string;
  tags: string;
}

export interface BusinessCategory {
  mcc: string;
  name: string;
  description: string;
  category: string;
  categoryDescription: string;
  sic: string;
  fastTrackMapping: string;
  tags: string;
}

const hitDTOToHit = (dto: CategoryHitDTO): CategoryHit => ({
  category: dto.category,
  categoryDescription: dto.category_description,
  description: dto.description,
  fasttrackMapping: dto.fasttrack_mapping,
  mcc: dto.mcc,
  name: dto.name,
  sic: dto.sic,
  tags: dto.tags,
});

export const getBusinessCategoriesFromSearch = async (
  application: Application,
  search: string,
  abortController: AbortController,
) => {
  const baseUrl = Environment.current?.apiHost;
  const ENDPOINT = `/cloud/public-services/financial-services/v1/vodapay/smme/mcc/code?input=${search}`;

  const loggingService = new LoggingService();

  const startTime = performance.now();
  return request(
    ENDPOINT,
    {
      fetchOptions: {
        method: 'GET',
        signal: abortController.signal,
      },
    },
    baseUrl,
    null,
    true,
    true,
  ).then((response) => {
    loggingService.info({
      traceId: getLoggingTraceId(),
      solutionType: application.solutionType,
      journey: getJourneyNameFromSessionStorage(),
      currentStep: getCurrentStep(application.steps, application.currentStepIndex),
      referenceNumber: application.referenceNumber,
      timestamp: new Date().toISOString(),
      api: {
        responseTime: (performance.now() - startTime).toFixed(),
        statusCode: response.status,
        endpoint: response.url,
        params: {
          code: search,
        },
        responseBody: response.result,
      },
      device: {
        platform: getOSName(navigator.userAgent),
        browserName: getBrowserName(navigator.userAgent),
      },
      url: window.location.href,
      environment: Environment.current.env,
    });

    if (response.status !== 200) {
      // error
      return [];
    }

    const hits: CategoryHitDTO[] = response.result.data;

    return hits.map((hit) => hitDTOToHit(hit));
  });
};
